const STONE_REBRAND_FAVICON_DIR = 'stonerebrand'

/**
 * Rewrites the favicon <link> tags to point at the Stone rebrand favicon set
 * (public/img/favicons/stonerebrand/*) at runtime. Called only when the
 * `stone-rebrand` feature flag is active, so the default build is untouched.
 */
export function applyStoneRebrandFavicon () {
  if (typeof document === 'undefined') return

  const links = document.querySelectorAll(
    'link[rel~="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
  )

  links.forEach(link => {
    const href = link.getAttribute('href')
    if (!href) return

    const swapped = href.replace(
      /(img\/favicons\/)[^/]+\//,
      `$1${STONE_REBRAND_FAVICON_DIR}/`
    )

    if (swapped !== href) link.setAttribute('href', swapped)
  })
}
